import { signInWithPopup, GoogleAuthProvider, signOut, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../firebase_setup/firebase';
import { useState, createContext} from "react";
import { useBasicComponentStates } from "../repositories/utils";

export const TodoContext = createContext({});

export const DataProvider = ({children}) => {

	const provider = new GoogleAuthProvider();

	const {
        loading: mainAppLoading, setLoading: mainAppSetLoading,
    } = useBasicComponentStates({editingForm: false});

	const [user, setUser] = useState();

	const fireBaseLogin = async (user, password) => {
		try {
			mainAppSetLoading(true);
			const newLogin = await signInWithEmailAndPassword(auth, user, password);
			setUser(newLogin.user);
			return{
				status: "ok"
			}
		} catch (error) {
			mainAppSetLoading(false);
			return {
				status: "error",
				errorCode: error.code
			}
		}
	}

	const registerWithGoogle = () => {
		signInWithPopup(auth, provider).then((result) => {
			const user = result.user;
			sessionStorage.setItem('user', JSON.stringify(user));
			setUser(user);
		}).catch((error) => {
			const credential = GoogleAuthProvider.credentialFromError(error);
			console.log('Error de autenticación :>> ', error.message);
		});
	};

	const logOut = () => {
		signOut(auth).then(() => {
	        setUser(null);
			sessionStorage.removeItem('user');
		}).catch((error) => {
			console.log('error :>> ', error);
		});
	};

	return(
		<TodoContext.Provider value={{ user, setUser, mainAppLoading, mainAppSetLoading, fireBaseLogin, registerWithGoogle, logOut }}>
			{children}
		</TodoContext.Provider>
	);
};